import Loading from 'Common/Components/Loading';
import GlobalLoader from 'Common/GlobalLoader';
import { useLoading } from 'Common/LoadingContext';
import useIsMobile from 'Common/useIsMobile';
import Layout from 'Layout';
import NonAuthLayout from 'Layout/NonLayout';
import React, { Suspense, useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { appDispatch } from 'slices';
import { LoginHook } from 'slices/auth/login/hook';
import { LayoutHook } from 'slices/layouts/hook';
import { setActivePathAction } from 'slices/layouts/reducer';
import { getAccount } from 'slices/thunk';
import { publicRoutes, routes } from './allRoutes';
import { loginUser } from 'slices/auth/login/reducer';

const Pages404 = React.lazy(() => import('pages/Components/Pages404'));

const ProtectedRoute = ({ route }: { route: any }) => {
  const { pathname } = useLocation();
  const dispatch = appDispatch();
  const { account, isAdmin, token } = LoginHook();
  const isMobile = useIsMobile();

  // const filteredMenu = useMemo(
  //   () => getAllowedMenu(account?.permissions, isAdmin),
  //   [account?.permissions, isAdmin],
  // );
  // const firstAllowedPath = useMemo(
  //   () => getFirstAllowedPath(filteredMenu) || '/pages-404',
  //   [filteredMenu],
  // );

  if (!token) {
    const localToken = localStorage.getItem('token');
    if (!localToken) {
      return <Navigate to="/login" replace />;
    } else {
      dispatch(loginUser(localToken));
    }
  }

  if (!account) {
    return <Loading />;
  }

  if (pathname === '/') {
    return <Navigate to={isMobile ? '/fast-access' : '/customer'} replace />;
  }

  if (isAdmin) {
    return <route.component />;
  }

  // const hasAccess = route.allowWithoutMenu
  //   ? true
  //   : route.permissionFeatures?.length
  //     ? hasAnyFeaturePermission(account?.permissions, route.permissionFeatures)
  //   : route.permissionFeature
  //     ? hasFeaturePermission(account?.permissions, route.permissionFeature)
  //     : isPathAllowed(filteredMenu, pathname);

  // if (!hasAccess) {
  //   return <Navigate to={firstAllowedPath} replace />;
  // }

  return <route.component />;
};

const NotFoundRoute = () => {
  const localToken = localStorage.getItem('token');

  if (localToken) {
    return (
      <Layout>
        <Pages404 />
      </Layout>
    );
  }

  return (
    <NonAuthLayout>
      <Pages404 />
    </NonAuthLayout>
  );
};

const App = () => {
  const dispatch = appDispatch();
  const { show, hide } = useLoading();
  const { pathname } = useLocation();
  const { loading } = LayoutHook();
  const { account } = LoginHook();

  useEffect(() => {
    const localToken = localStorage.getItem('token');
    if (!localToken || account) return;
    dispatch(getAccount());
  }, [account, pathname]);

  useEffect(() => {
    show();
    const id = setTimeout(() => hide(), 100);
    dispatch(setActivePathAction(pathname as any));
    return () => clearTimeout(id);
  }, [hide, pathname, show]);

  useEffect(() => {
    if (loading) {
      show();
      return;
    }
    hide();
  }, [loading, show, hide]);

  useEffect(() => {
    const gestureZoom = (e: any) => {
      if (e.scale !== 1) {
        e.preventDefault();
      }
    };

    const touchZoom = (e: TouchEvent) => {
      if (e.touches.length > 1) {
        e.preventDefault();
      }
    };

    document.addEventListener('touchmove', touchZoom, { passive: false });
    document.addEventListener('gesturestart', gestureZoom);
    document.addEventListener('gesturechange', gestureZoom);
    return () => {
      document.removeEventListener('gesturestart', gestureZoom);
      document.removeEventListener('gesturechange', gestureZoom);
      document.removeEventListener('touchmove', touchZoom);
    };
  }, []);

  return (
    <React.Fragment>
      <GlobalLoader />
      <Suspense fallback={<Loading />}>
        <Routes>
          {routes.map((route: any, idx: number) => (
            <Route
              key={idx}
              path={route.path}
              element={
                <Layout>
                  <ProtectedRoute route={route} />
                </Layout>
              }
            />
          ))}
          {publicRoutes.map((route: any, idx: number) => (
            <Route
              path={route.path}
              key={idx}
              element={
                <NonAuthLayout>
                  <route.component />
                </NonAuthLayout>
              }
            />
          ))}
          <Route path="*" element={<NotFoundRoute />} />
        </Routes>
      </Suspense>
    </React.Fragment>
  );
};

export default App;
